import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';


function FarmerOnboardingHeader() {
  const location = useLocation();
  const isOnboardingActive = location.pathname.includes('/farmer-onboarding');
  const isImportActive = location.pathname.includes('/farmer-import');

  const user = useSelector((state) => state.user);
  const personRoles = _.get(user, 'profile.person_role') || []
  const isCTFacilitator = user?.profile?.person_role?.some(item => item?.role_code === 'CT Facilitator');
  const isCTSuperUser = personRoles.some((item) => item.role_id == 20);
  const isSupplyPartner = _.get(user, 'profile.is_supply_partner') || false
  const userHasRights = (isCTFacilitator || isCTSuperUser || isSupplyPartner);


  return (
    <div className="bfc-header bfc-invoice-header">
      <div className="content-wrapper">
        <div className="content-block">
          <div className="top-content">
            <div className="d-flex align-items-center">
              <Link
                to="/network/farmer-onboarding"
                className={classnames('mr-4', { 'active': isOnboardingActive })}
                style={{
                  fontSize: '18px',
                  fontWeight: isOnboardingActive ? 'bold' : 'normal',
                  color: isOnboardingActive ? 'var(--unnamed-color-1b62ab)' : '#666',
                  borderBottom: isOnboardingActive ? '3px solid var(--unnamed-color-1b62ab)' : 'none',
                  padding: '8px 0',
                  marginRight: '24px',
                  textDecoration: 'none',
                  transition: 'all 0.2s ease'
                }}
              >
                Farmer Onboarding
              </Link>
              {userHasRights && (
                <Link
                  to="/network/farmer-import"
                  className={classnames({ 'active': isImportActive })}
                  style={{
                    fontSize: '18px',
                    fontWeight: isImportActive ? 'bold' : 'normal',
                    color: isImportActive ? 'var(--unnamed-color-1b62ab)' : '#666',
                    borderBottom: isImportActive ? '3px solid var(--unnamed-color-1b62ab)' : 'none',
                    padding: '8px 0',
                    textDecoration: 'none',
                    transition: 'all 0.2s ease'
                  }}
                >
                  Farmer Import
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FarmerOnboardingHeader;
